import axios from "axios";

export default axios.create({
    baseURL: "https://service.asraimmigration.ca/backend_service/v1/"
});
